import React, { useMemo, useContext, useCallback, useState } from 'react';
import ReminderCardStatusEngine from './ReminderCardStatusEngine';
import ReminderCardDateEngine from './ReminderCardDateEngine';
import GeneralContext from '../../GeneralContext';
import CopyIcon from '../../../icons/Copy';
import EditIcon from '@material-ui/icons/Subject';
import { FetchCallbacksContext } from '../../FetchCallbacks';
import dotProp from 'dot-prop';
import _isEqual from 'lodash.isequal';

const reminderTypes = {
  status: ReminderCardStatusEngine,
  date: ReminderCardDateEngine
};

const ReminderCardEngine = ({ reminderData, ...props }) => {
  const api = useContext(GeneralContext);
  const { duplicateReminder, updateReminder, validateReminderTitle } = api;
  const { openSnackbar } = useContext(FetchCallbacksContext);

  const [title, setTitle] = useState(reminderData.title || '');

  const onDisabledClicked = useCallback(() => {
    openSnackbar('warning', 'snackbars.reminders.locked');
  }, []);

  const update = useCallback(
    (payload, snackbarMsg) => {
      const keys2Update = Object.keys(payload);
      if (
        keys2Update.every(
          key => dotProp.get(reminderData, key) === payload[key]
        )
      ) {
        return;
      }
      keys2Update.forEach(key => dotProp.set(reminderData, key, payload[key]));
      updateReminder(reminderData, snackbarMsg);
    },
    [reminderData]
  );

  const updateTitle = useCallback(() => {
    if (validateReminderTitle(title, reminderData.id)) {
      update({ title: title });
    } else {
      // TODO: think of a different way to handle this
      setTimeout(
        () => openSnackbar('error', 'snackbars.reminders.title_error'),
        100
      );
    }
  }, [title]);

  const ReminderCardView = useMemo(
    () =>
      reminderTypes[
        reminderData && reminderData.condition
          ? reminderData.condition.conditionType
          : null
      ],
    []
  );

  const actionButtons = useMemo(
    () => [
      {
        onAction: () => duplicateReminder(reminderData),
        icon: CopyIcon,
        tooltip: 'Duplicate',
        internalName: 'duplicate'
      },
      {
        onAction: () => {
          api.onEditEmailClicked(reminderData);
        },
        icon: EditIcon,
        tooltip: 'Edit email template',
        internalName: 'edit-template'
      }
    ],
    [duplicateReminder, reminderData]
  );

  const viewProps = {
    update,
    onDisabledClicked,
    actionButtons,
    reminderData,
    title,
    setTitle,
    updateTitle,
    ...props
  };

  return <ReminderCardView {...viewProps} />;
};

export default React.memo(ReminderCardEngine, _isEqual);
